import {
  type OasWebPageTreeNode,
  type OasWebPages,
  isOasWebMenuNode,
  isOasWebPageApiTable,
  isOasWebTabsPage,
  oasWebPageGroups,
} from '@ipfabric/utils';
import type { AppTranslations } from 'translations/translations';

const getApiTablePath = (
  treeNodes: OasWebPageTreeNode[],
  tags: string[] = [],
): Record<string, string[]> =>
  treeNodes.reduce<Record<string, string[]>>((acc, node) => {
    if (isOasWebTabsPage(node)) {
      Object.assign(acc, getApiTablePath(node.tabs, [...tags, node.title]));
      return acc;
    }
    if (isOasWebPageApiTable(node)) {
      acc[node.apiTable] = tags;
    } else if (isOasWebMenuNode(node)) {
      Object.assign(acc, getApiTablePath(node.submenu, [...tags, node.title]));
      return acc;
    }

    return acc;
  }, {});

export const getApiTableTagsMap = (
  xWebPages: OasWebPages,
  msg: AppTranslations['app']['sidebar'],
): Record<string, string[]> =>
  oasWebPageGroups.reduce<Record<string, string[]>>((acc, group) => {
    if (xWebPages[group]) {
      Object.assign(acc, getApiTablePath(xWebPages[group], [msg[group]]));
    }
    return acc;
  }, {});
